import countryMapping from './mappings/countryMapping';

/**
 * Get regulation by country code.
 *
 * @param {string} countryCode Country code.
 * @returns {Array} Country regulation.
 */
const getCountryRegulation = (countryCode) => {
    let countryMap = countryMapping.find(country => country.countryCode.includes(countryCode));
    let baseCountryRegulations = countryMap ? countryMap.regulations : [];

    return [...baseCountryRegulations];
};

export default getCountryRegulation;